import { render } from "./CosulMeu.vue?vue&type=template&id=71687187&scoped=true"
import script from "./CosulMeu.vue?vue&type=script&lang=js"
export * from "./CosulMeu.vue?vue&type=script&lang=js"

import "./CosulMeu.vue?vue&type=style&index=0&id=71687187&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\cazino\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71687187"]])

export default __exports__